var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CloudColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.87819081e-06%",
    y1: "21.5084708%",
    x2: "100.11691%",
    y2: "23.9217624%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-14.9%",
    y: "-18.5%",
    width: "129.8%",
    height: "136.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.87819081e-06%",
    y1: "21.5085036%",
    x2: "100.11691%",
    y2: "23.9217587%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.940992,74.2533987 L156.525992,74.2533987 C156.525992,74.2533987 156.435992,48.1217987 156.525992,42.6251987 C156.705992,35.0559987 151.749992,27.4868987 141.837992,21.8099987 C131.655992,15.8627987 118.048992,13.0694987 104.622992,13.3397987 C102.730992,10.8166987 100.117992,8.47390866 96.6029921,6.40140866 C83.6276921,-1.07763134 63.7135921,-1.97872134 48.9356921,3.60802866 C36.0501921,0.724544657 20.9118921,2.25639866 10.5492921,8.20358866 C3.52079215,12.2584987 0.00659214612,17.5748987 0.00659214612,22.8912987 C0.00659214612,28.2077987 0.186792146,52.3569987 0.00659214612,57.5832987 C-0.173607854,62.9897987 3.34059215,68.4864987 10.5492921,72.5413987 L99.4869921,123.902999 C113.543992,132.012999 136.250992,132.012999 150.307992,123.902999 C157.065992,120.028999 160.580992,114.892999 160.850992,109.755999 C161.120992,104.349999 160.940992,74.2533987 160.940992,74.2533987 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.5%",
    width: "110.6%",
    height: "113.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0390862%",
    y1: "48.8235346%",
    x2: "93.8843144%",
    y2: "50.2129133%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84849973%",
    y1: "49.4736829%",
    x2: "96.9699014%",
    y2: "49.4736829%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.378992,88.9412987 C136.321992,97.0510987 113.613992,97.0510987 99.5569921,88.9412987 L10.6198921,37.5791987 C-3.43710785,29.4693987 -3.43710785,16.3134987 10.6198921,8.20366866 C20.9823921,2.25647866 36.1206921,0.724624657 49.0062921,3.60810866 C63.7841921,-1.97864134 83.6981921,-1.07755134 96.4939921,6.31137866 C100.007992,8.38387866 102.620992,10.7266987 104.512992,13.2497987 C117.939992,12.9793987 131.545992,15.7727987 141.727992,21.7199987 C158.938992,31.6319987 161.101992,47.0405987 148.035992,58.3041987 C148.358992,58.4835987 148.681992,58.6487987 148.998992,58.8109987 C149.478992,59.0560987 149.944992,59.2945987 150.378992,59.5657987 C164.435992,67.6755987 164.435992,80.8314987 150.378992,88.9412987 Z M49.6902921,13.2639987 C56.9732921,11.1950987 66.4384921,10.5214987 75.5068921,11.7649987 C84.4465921,12.9907987 93.4699921,16.1479987 99.5959921,22.1715987 C110.544992,22.0037987 121.481992,22.0734987 130.622992,26.4377987 C138.360992,30.0847987 143.082992,35.0191987 143.306992,41.0433987 C143.524992,46.9178987 139.364992,52.1820987 133.487992,56.3254987 C132.133992,57.2802987 130.262992,56.9566987 129.307992,55.6025987 C128.352992,54.2484987 128.676992,52.3767987 130.030992,51.4219987 C135.386992,47.6449987 137.413992,44.0313987 137.310992,41.2656987 C137.213992,38.6516987 135.111992,35.1847987 128.058992,31.8620987 L128.050992,31.8586987 L128.043992,31.8550987 C120.040992,28.0318987 110.093992,27.9988987 98.3929921,28.1915987 L97.0439921,28.2137987 L96.1329921,27.2194987 C91.3539921,22.0080987 83.4408921,18.9089987 74.6917921,17.7092987 C65.9927921,16.5164987 56.9831921,17.2769987 50.5113921,19.2781987 L49.5628921,19.5714987 L48.6265921,19.2410987 C38.8153921,15.7778987 27.4353921,15.5759987 18.3743921,22.0806987 C17.0284921,23.0468987 15.1540921,22.7390987 14.1878921,21.3931987 C13.2215921,20.0472987 13.5293921,18.1728987 14.8753921,17.2065987 C25.7482921,9.40103866 38.9167921,9.69776866 49.6902921,13.2639987 Z M137.593992,66.4201987 C138.635992,65.1317987 140.524992,64.9317987 141.812992,65.9734987 C144.426992,68.0872987 146.104992,70.8620987 146.224992,73.9685987 C146.345992,77.0936987 144.867992,79.9592987 142.366992,82.1753987 C141.126992,83.2743987 139.230992,83.1601987 138.131992,81.9202987 C137.032992,80.6803987 137.147992,78.7843987 138.386992,77.6852987 C139.851992,76.3871987 140.265992,75.1527987 140.228992,74.2004987 C140.191992,73.2295987 139.660992,71.9495987 138.040992,70.6391987 C136.751992,69.5974987 136.551992,67.7085987 137.593992,66.4201987 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CloudColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.940992,84.2463987 L156.525992,84.2463987 C156.525992,84.2463987 156.435992,58.1147987 156.525992,52.6180987 C156.705992,45.0489987 151.749992,37.4797987 141.837992,31.8029987 C131.655992,25.8557987 118.048992,23.0623987 104.622992,23.3326987 C102.730992,20.8096987 100.117992,18.4667987 96.6029921,16.3942987 C83.6276921,8.91528866 63.7135921,8.01419866 48.9356921,13.6009987 C36.0501921,10.7174987 20.9118921,12.2492987 10.5492921,18.1964987 C3.52079215,22.2513987 0.00659214612,27.5677987 0.00659214612,32.8842987 C0.00659214612,38.2006987 0.186792146,62.3498987 0.00659214612,67.5761987 C-0.173607854,72.9826987 3.34059215,78.4793987 10.5492921,82.5342987 L99.4869921,133.895999 C113.543992,142.005999 136.250992,142.005999 150.307992,133.895999 C157.065992,130.021999 160.580992,124.884999 160.850992,119.748999 C161.120992,114.342999 160.940992,84.2463987 160.940992,84.2463987 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.7,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.5569921,88.9412987 C113.613992,97.0510987 136.321992,97.0510987 150.378992,88.9412987 C164.435992,80.8314987 164.435992,67.6755987 150.378992,59.5657987 C149.657992,59.1151987 148.846992,58.7547987 148.035992,58.3041987 C161.101992,47.0405987 158.938992,31.6319987 141.727992,21.7199987 C131.545992,15.7727987 117.939992,12.9793987 104.512992,13.2497987 C102.620992,10.7266987 100.007992,8.38387866 96.4939921,6.31137866 C83.6981921,-1.07755134 63.7841921,-1.97864134 49.0062921,3.60810866 C36.1206921,0.724624657 20.9823921,2.25647866 10.6198921,8.20366866 C-3.43710785,16.3134987 -3.43710785,29.4693987 10.6198921,37.5791987 L99.5569921,88.9412987 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudColor);
export default __webpack_public_path__ + "static/media/CloudColor.72b777ed527cb1269e17d5ae494fa187.svg";
export { ForwardRef as ReactComponent };